<style scoped lang="less">
  .nota-obs { font-style: italic; color: #333333; padding: 10px; text-align: center; }
</style>
<template>
    <div class="app-form frame-page basic-form-vue">
      <div class="h-panel">
        <div class="h-panel-bar">
          <span class="h-panel-title">Arquivo <strong>{{arquivo.nome}}</strong> processado em {{formatDateTime(arquivo.atualizadoEm)}}</span>
        </div>

        <div class="h-panel-body">

          <div class="h-row">
            <div class="h-tabs common-status-filter-tabs">
              <div class="h-tabs-item h-tabs-selected h-tabs-item-selected">
                <p class="code">{{arquivo.status}}</p>
                <p class="name">Status</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.tipoDocumentoImportado}}</p>
                <p class="name">Tipo Documento</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.totalRegistrosUnicos}}</p>
                <p class="name">Total Itens</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.totalLidos}}</p>
                <p class="name">Inseridos</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.totalAtualizados}}</p>
                <p class="name">Atualizados</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.totalIgnorados}}</p>
                <p class="name">Ignorados</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{arquivo.totalNotas}}</p>
                <p class="name">Notas</p>
              </div>

              <div class="h-tabs-item">
                <p class="code">{{duracao}}</p>
                <p class="name">Tempo processamento</p>
              </div>
            </div>
          </div>

          <div class="h-row">&nbsp;</div>

          <div class="h-row" v-if="arquivo.notas && arquivo.notas.length === 0">
            Não existem notas de processamento
          </div>

          <div class="h-row" v-if="arquivo.notas && arquivo.notas.length > 0">
            <Table :height="400" border ref="table" :datas="arquivo.notas">
              <TableItem :width="40" title="">
                <template slot-scope="{data}">
                  <i v-if="data.nivel === 'i'" title="Informação" class="h-icon h-icon-info blue-color"></i>
                  <i v-if="data.nivel === 'w'" title="Aviso" class="h-icon h-icon-warn yellow-color"></i>
                  <i v-if="data.nivel === 'e'" title="Erro" class="h-icon h-icon-error red-color"></i>
                </template>
              </TableItem>
              <TableItem :width="145" title="Data" :render="formatarData"></TableItem>
              <TableItem title="Mensagem" prop="message"></TableItem>
            </Table>
          </div>

          <div class="h-row nota-obs" v-if="arquivo.notas && arquivo.notas.length > 0 && arquivo.notas.length !== arquivo.totalNotas">
            Esse arquivo gerou muitas notas de processamento. Como a maioria das notas são iguais, nós exibimos apenas às {{arquivo.notas.length}} primeiras notas
          </div>

        </div>
      </div>

    </div>
</template>
<script>
export default {
  data() {
    return {
      arquivo: {}
    };
  },
  computed: {
    duracao() {
      if (this.arquivo.duracao === undefined || !this.arquivo.duracao) {
        return '-';
      }
      return this.arquivo.duracao.split('.')[0];
    }
  },
  mounted: async function () {
    this.$Loading();
    if (this.$route.params.id !== undefined) {
      const resp = await R.Arquivo.get(this.$route.params.id);
      if (resp.data === null) {
        this.$router.push('/arquivos');
        return;
      }
      this.arquivo = resp.data;
    }
    this.$Loading.close();
  },
  methods: {
    formatDateTime: (date) => Utils.formatDateTime(date, 'DD/MM/YYYY hh:mm'),
    formatarData(data) {
      return Utils.formatDateTime(data.date, 'DD/MM/YYYY hh:mm:ss');
    }
  }
};
</script>
